



























import {Component, PropSync} from 'vue-property-decorator'
import {Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {SystemActionFilter} from "@/store/user_management/system_actions/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import { notifyError } from '@/utils/notify-helper';
import { getTranslatedParams } from '@/utils/notify-utils';
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings, ToggleWings}})
export default class SystemActionsFilter extends BaseFilter<SystemActionFilter> {
  @PropSync('show') is_show!: boolean;
  @Action("getSystemUsersAction") actionSystemUsersAction: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): SystemActionFilter {
    return {
      action_source: undefined,
    };
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "User action setting",
        addititional_info: getTranslatedParams(this.filter)
      }
      await this.actionSystemUsersAction(this.filter);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

}
